namespace $.$$ {
	$mol_style_define( $shm_hitalama_map_widget_float_table_filter, {
		flex: { direction: 'column' },
		minWidth: 0,
		Error: { whiteSpace: 'normal', maxWidth: '100%' },
	} )
}
